export enum Validity {
	INVALID,
	VALID,
	INCOMPLETE,
	RESTORED,
}
